import { AutoComplete } from 'antd';
import { useContext, useEffect, useState } from 'react';
import AppContext from '../../App.context';
import { getMainAddressByPersonID } from '../../api/NetworkingAddresses';
import { getAllCountries, getCountryByName } from '../../api/NetworkingCountries';
import { getCustomerById, searchCustomerByIdNameMin } from '../../api/NetworkingCustomers';
import { getStatesByCountryMin } from '../../api/NetworkingStates';
import { LookUpTableDetail } from '../../api/hooks/useLookUpTables';
import { formatValidInputClass, validInputClass } from '../../helpers/FormatHelper';
import { getResource } from '../../helpers/ResourcesHelper';
import Button from '../inputs/Button';
import Dropdown from '../inputs/Dropdown';
import Input from '../inputs/Input';
interface BeneProps {
  beneFields: number;
  [x: string]: any;
}
const BeneficiayInformation: React.FC<BeneProps> = ({ beneFields, ...props }) => {
  const { showModal } = useContext(AppContext);
  const [beneficiaryID, setBeneficiaryID] = useState(0);
  const [beneficiaryType, setBeneficiaryType] = useState('');
  const [beneficiaryName, setBeneficiaryName] = useState('');
  const [beneficiaryFirstName, setBeneficiaryFirstName] = useState('');
  const [beneficiaryLastName, setBeneficiaryLastName] = useState('');
  const [beneficiaryShortName, setBeneficiaryShortName] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [status, setStatus] = useState('');
  const [city, setCity] = useState('');
  const [countryID, setCountryID] = useState('');
  const [countryIDName, setCountryIDName] = useState('');
  const [stateID, setStateID] = useState(0);
  const [stateName, setStateName] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [load, setLoad] = useState(true);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const allowCreateBeneficiaryFromCustomer = localStorage.getItem('CreateBeneficiaryFromCustomer');
  const [customerList, setCustomerList] = useState([]);
  const [customerID, setCustomerID] = useState(0);
  const [customerSearch, setCustomerSearch] = useState('');
  const [customerPersonID, setCustomerPersonID] = useState('');



  const [validations, setValidations] = useState({
    beneficiaryType: true,
    beneficiaryFirstName: true,
    beneficiaryName: true,
    beneficiaryLastName: true,
    addressLine1: true,
    stateID: true,
    countryID: true
  });

  const validationsFields = () => {
    var type = validInputClass(beneficiaryType);
    var firstName = validInputClass(beneficiaryFirstName);
    var name = validInputClass(beneficiaryName);
    var lastName = validInputClass(beneficiaryLastName);
    var address = validInputClass(addressLine1);
    var country = validInputClass(countryID);
    var state = validInputClass(stateID.toString());
    setValidations({
      beneficiaryType: type,
      beneficiaryFirstName: firstName,
      beneficiaryName: name,
      beneficiaryLastName: lastName,
      addressLine1: address,
      countryID: country,
      stateID: state
    });
    var nameValid = (beneficiaryType == 'Personal') ? firstName && lastName : name;
    var isValid = type && nameValid && address && country && state;
    if (!isValid) { showModal(getResource('Js_MessageError_TitleError'), getResource('Js_MessageError_FormValidationNFieldNHighlighted')); }
    else {
      props.onUpdateStep(1);
    }
  }
  useEffect(() => {
    const loadCountries = async () => {
      const json = await getAllCountries();
      if (json != null && json.countries != null) {
        console.log(json);
        const formattedCountries = json.countries.map((c: any) => ({ ...c, label: `${c.Country} - ${c['Country Name']}`, value: c.Country }));
        formattedCountries.push({ label: getResource('SelectCountry'), value: '' });
        setCountries(formattedCountries);
      } else {
        setCountries(props.countries);
      }
    }
    loadCountries();
  }, [props.countries]);

  useEffect(() => {
    const loadStates = async () => {
      const json = await getStatesByCountryMin(props.beneficiary.CountryID);
      if (json != null && json.states != null) {
        const formattedStates = json.states.map((x: any) => ({ label: x['State Name'], value: x['State ID'] }));
        //let state = formattedStates.find((x: typeof states) => x.value === stateID);
        setStates(formattedStates);
      } else {
        setStates([]);
      }
      if (props.beneficiary.CountryID !== '' && props.beneficiary.CountryName != null && props.beneficiary.CountryName !== '') setCountryID(props.beneficiary.CountryID + ' - ' + props.beneficiary.CountryName);
    }
    loadStates();
  }, [props.beneficiary.CountryID])

  useEffect(() => {
    if (props.beneficiary != null) {
      setBeneficiaryID(props.beneficiary.BeneficiaryID);
      if (props.beneficiary.CountryID !== '' && props.beneficiary.CountryName != null && props.beneficiary.CountryName !== '') setCountryID(props.beneficiary.CountryID + ' - ' + props.beneficiary.CountryName);
      setBeneficiaryType(props.beneficiary.BeneficiaryType);
      setBeneficiaryName(props.beneficiary.BeneficiaryName);
      setBeneficiaryFirstName(props.beneficiary.BeneficiaryFirstName);
      setBeneficiaryLastName(props.beneficiary.BeneficiaryLastName);
      setBeneficiaryShortName(props.beneficiary.BeneficiaryShortName);
      setAddressLine1(props.beneficiary.AddressLine1);
      setAddressLine2(props.beneficiary.AddressLine2);
      setCity(props.beneficiary.City);
      setPostalCode(props.beneficiary.PostalCode);
      setStateID(props.beneficiary.StateID);
      setStateName(props.beneficiary.StateName);
      setStatus(props.beneficiary.Status);
    }
  }, [props.beneficiary]);

  useEffect(() => {
    if (beneFields != null && beneFields > 0) {
      validationsFields();
    }
  }, [beneFields]);

  const updateStates = (countryID: string) =>
  {
    getStatesByCountryMin(countryID).then(response => {
    
      if (response != null && response.httpStatusCode === 200 && response.states != null) {
          let states = response.states
          states = states.map((x: typeof states) => ({ label: x['State Name'], value: x['State ID'] }));
        let state = states.find((x: typeof states) => x.value == stateID);
        if (state == null) {
          setStateID(0);
          setStateName('');
        }
        setStates(states);
      }
  });
  }

  const beneficiaryTypeChangeHandler = (detail: LookUpTableDetail) => {
    if (detail != null) {
      setBeneficiaryType(detail.value);
      setValidations({ ...validations, beneficiaryType: true });
      props.onUpdateBeneficiary('BeneficiaryType', detail.value);
    }
  };

  const countryChangeHandler = (item: any, option: any) => {

    if (option != null && !option.label.includes('Select')) {
      setCountryID(option.label);
      props.onUpdateBeneficiary('CountryID', item);
      props.onUpdateBeneficiary('CountryName', option['Country Name']);
      setValidations({ ...validations, countryID: true });
      updateStates(item);
      if (!load) {
        //setStateID(0);
      } else {
        setLoad(false);
      }
    }
  }

  const onSearch = (value: any) => {
    setCountryID(value);
    let newValue = value.split(' -');
    if (value === '') setStates([]);
    getCountryByName(newValue[0]).then(
      (json) => {
        if (json.countries != null) {
          const formattedCountries = json.countries.map((c: any) => ({ ...c, label: c.CountryIdName, value: c.CountryId }));
          //formattedCountries.push({ label: 'Select a Country...', value: '' });
          setCountries(formattedCountries);
        }
      }
    )
  }

  const customerChangeHandler = (item: any, option: any) => {
    if (option != null && !option.label.includes('Select')) {
      console.log(item, option);
      setCustomerSearch(option.label);
      setCustomerID(option.value);
      setCustomerPersonID(option.PersonID);
    }
  }

  const onSearchCustomer = (value: any) => {
    setCustomerSearch(value);
    searchCustomerByIdNameMin(value).then(
      (response) => {
        if (response.customers !== undefined) {
          for (var i = 0; i < response.customers.length; i++) {
            response.customers[i].value = response.customers[i].CustomerID;
            response.customers[i].label = response.customers[i].CustomerIDName;
          }
          setCustomerList(response.customers);
        }
      }
    )
  }

const stateChangeHandler = (item: any, name: string) => {
    if(item != null)
    {
        setStateID(item.value);
      props.onUpdateBeneficiary('StateID', item.value);
      setValidations({ ...validations, stateID: true });
    }
}

const onChangeName = (e: any) =>
{ 
    setBeneficiaryName(e.target.value);
  setValidations({ ...validations, beneficiaryName: true });
    props.onUpdateBeneficiary('BeneficiaryName', e.target.value);
}

const onChangeFirstName = (e: any) =>
{ 
    setBeneficiaryFirstName(e.target.value);
  setValidations({ ...validations, beneficiaryFirstName: true });
    props.onUpdateBeneficiary('BeneficiaryFirstName', e.target.value);
}

const onChangeLastName = (e: any) =>
{ 
    setBeneficiaryLastName(e.target.value);
  setValidations({ ...validations, beneficiaryLastName: true });
    props.onUpdateBeneficiary('BeneficiaryLastName', e.target.value);
}

const onChangeShortName = (e: any) =>
{ 
    setBeneficiaryShortName(e.target.value);
    props.onUpdateBeneficiary('BeneficiaryShortName', e.target.value);
}

const onChangeAddress1 = (e: any) =>
{ 
    setAddressLine1(e.target.value);
  setValidations({ ...validations, addressLine1: true });
    props.onUpdateBeneficiary('AddressLine1', e.target.value);
}

const onChangeAddress2 = (e: any) =>
{ 
    setAddressLine2(e.target.value);
    props.onUpdateBeneficiary('AddressLine2', e.target.value);
}

const onChangeCity= (e: any) =>
{ 
    setCity(e.target.value);
    props.onUpdateBeneficiary('City', e.target.value);
}

const onChangePostalCode = (e: any) =>
{ 
    setPostalCode(e.target.value);
    props.onUpdateBeneficiary('PostalCode', e.target.value);
}

  const onUseCustomerInformation = async () => {
    if (customerID > 0 && customerPersonID !== '') {
      let userSession = JSON.parse(localStorage.getItem('UserSession')!);
      debugger
      if (userSession.CustomerID === customerID) {
        showModal(getResource('Js_MessageError_TitleError'), getResource('Message_Beneficiary_CustomerSession'));
        return true;
      }
      if (props.beneficiaries) {
        let exists = props.beneficiaries.find((b: any) => b.BeneficiaryPersonID === customerPersonID);
        if (exists) {
          showModal(getResource('Js_MessageError_TitleError'), getResource('Message_Beneficiary_CustomerExists'));
          return true;
        }
      }
      let customerInfo = await getCustomerById(customerID);
      if (customerInfo && customerInfo.CustomerID > 0) {
        let address = await getMainAddressByPersonID(customerInfo.PersonID);
        if (address) {
          let beneficiary = {
            BeneficiaryID: 0,
            BeneficiaryType: customerInfo.CustomerType === 'Individual' ? 'Personal' : customerInfo.CustomerType,
            BeneficiaryName: customerInfo.Name,
            BeneficiaryFirstName: customerInfo.FirstName,
            BeneficiaryLastName: customerInfo.LastName,
            BeneficiaryShortName: customerInfo.ShortName,
            AddressLine1: address.AddressValue,
            AddressLine2: address.Address2,
            CustomerID: 0,
            City: address.City,
            CountryID: address.CountryId ? address.CountryId.trim() : '',
            CountryName: address.CountryName,
            StateID: address.StateId,
            StateName: address.StateName,
            Status: 'Pending activation',
            PostalCode: address.POBox,
            PreferredMethodOfPayment: '',
            PreferredDeliveryMethod: '',
            EmailAddress: customerInfo.Email,
            PaymentLimit: 0,
            DetailsOfPayment: '',
            PaymentReference: '',
            PhoneNumber: customerInfo.Phone,
            PhoneExtension: customerInfo.PhoneExt,
            FaxNumber: customerInfo.OfficeFax,
            MobileNumber: customerInfo.MobilePhone,
            ExternalBeneficiaryKey: '',
            UpdatedBy: '',
            UpdateToken: '',
            UpdatedByContactID: 0,
            PersonID: customerInfo.PersonID
          }
          props.onUpdateBeneficiaryObj(beneficiary, true);
        }
      }
    }
  }

  const onClearCustomerInformation = () => {
    let beneficiary = {
      BeneficiaryID: 0,
      BeneficiaryType: '',
      BeneficiaryName: '',
      BeneficiaryFirstName: '',
      BeneficiaryLastName: '',
      BeneficiaryShortName: '',
      AddressLine1: '',
      AddressLine2: '',
      CustomerID: 0,
      City: '',
      CountryID: '',
      CountryName: '',
      StateID: 0,
      StateName: '',
      Status: '',
      PostalCode: '',
      PreferredMethodOfPayment: '',
      PreferredDeliveryMethod: '',
      EmailAddress: '',
      PaymentLimit: 0,
      DetailsOfPayment: '',
      PaymentReference: '',
      PhoneNumber: '',
      PhoneExtension: '',
      FaxNumber: '',
      MobileNumber: '',
      ExternalBeneficiaryKey: '',
      UpdatedBy: '',
      UpdateToken: '',
      UpdatedByContactID: 0
    }
    setCountryID('');
    setCountryIDName('');
    setBeneficiaryType('');
    setCustomerID(0);
    setCustomerSearch('');
    setCustomerList([]);
    setCustomerPersonID('');
    props.onUpdateBeneficiaryObj(beneficiary, false);
  }

    return (
      <div className={props.canEdit ? '' : 'readonly'}>
        {allowCreateBeneficiaryFromCustomer === 'true' && beneficiaryID === 0 &&
          <div className="row">
            <div className="col-md-6 col-xs-6">
              <div className="row">
                <span className="input-label">{getResource('Label.InvoiceCustomerName')}</span>
              </div>
              <div className="row">
                <AutoComplete
                  allowClear
                  options={customerList}
                  className={""}
                  placeholder={getResource('SelectCustomer')}
                  notFoundContent={getResource('PlaceHolder.NoResults')}
                  value={customerSearch}
                  onSelect={customerChangeHandler}
                  onSearch={onSearchCustomer}
                />
              </div>
            </div>
            <div className="col-md-6 col-xs-6">
              <div className="row" style={{ marginTop: '25px' }}>
                <div className="col-xs-6 col-md-6">
                  <Button type="primary-xs" onClick={onUseCustomerInformation}>
                    {getResource('Button.Use')}
                  </Button>
                </div>
                <div className="col-xs-6 col-md-6">
                  <Button type="primary-xs" onClick={onClearCustomerInformation}>
                    {getResource('Button.Clear')}
                  </Button>
                </div>

              </div>
            </div>
          </div>}
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <div className="row">
                <span className="input-label">{getResource('Label.BeneficiaryType') + '(*)'}</span>
              </div>
              <div className="row">
                <Dropdown
                  name="beneficiaryType"
                  title={getResource('SelectType') + '...'}
                  list={props.beneficiaryTypes.filter((x: { value: string; }) => !['Select a Type...'].includes(x.value))}
                  select={{ value: beneficiaryType }}
                  errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.beneficiaryType)}
                  onChange={beneficiaryTypeChangeHandler}
                disabled={props.customerInfoUsed}
                />
              </div>
            </div>
          <div className="col-md-6 col-xs-12">
            {beneficiaryID > 0 && <>
              <div className="row">
                <span className="input-label">{getResource('Label.Status')}</span>
              </div>
              <div className="row readonly">
                <Input type="text" value={status} ></Input>
              </div>
            </>}

          </div>
          </div>
          {beneficiaryType !== 'Corporate' && (
          <div className="row">
              <div className="col-md-6 col-xs-12">
                <div className="row">
                  <span className="input-label">{getResource('Label.FirstName') + '(*)'}</span>
                </div>
                <div className="row">
                  <Input type="text" onChange={onChangeFirstName} value={beneficiaryFirstName} errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.beneficiaryFirstName)}
                  disabled={props.customerInfoUsed}></Input>
                </div>
              </div>
              <div className="col-md-6 col-xs-12">
                <div className="row">
                  <span className="input-label">{getResource('Label.LastName') + '(*)'}</span>
                </div>
                <div className="row">
                  <Input type="text" onChange={onChangeLastName} value={beneficiaryLastName} errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.beneficiaryLastName)} disabled={props.customerInfoUsed}></Input>
                </div>
              </div>
            </div>
          )}
          {beneficiaryType === 'Corporate' && (
          <div className="row">
              <div className="col-md-6 col-xs-12">
                <div className="row">
                  <span className="input-label">{getResource('Js_TH_Name') + '(*)'}</span>
                </div>
                <div className="row">
                  <Input type="text" onChange={onChangeName} value={beneficiaryName} errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.beneficiaryName)} disabled={props.customerInfoUsed}></Input>
                </div>
              </div>
            </div>
          )}
        <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.ShortName')}</span>
              </div>
              <div className="row">
              <Input type="text" onChange={onChangeShortName} value={beneficiaryShortName} disabled={props.customerInfoUsed}></Input>
              </div>
            </div>
          </div>
        <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.Address1') + '(*)'}</span>
              </div>
              <div className="row">
                <Input type="text" onChange={onChangeAddress1} value={addressLine1} errorMessage={getResource('DataMsgRequired')}
                className={formatValidInputClass(validations.addressLine1)} disabled={props.customerInfoUsed}></Input>
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.Address2')}</span>
              </div>
              <div className="row">
              <Input type="text" onChange={onChangeAddress2} value={addressLine2} disabled={props.customerInfoUsed}></Input>
              </div>
            </div>
          </div>
        <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.City')}</span>
              </div>
              <div className="row">
              <Input type="text" onChange={onChangeCity} value={city} disabled={props.customerInfoUsed}></Input>
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.Country') + '(*)'}</span>
              </div>
              <div className="row">                
                <AutoComplete
                  allowClear
                  options={countries}
                  className={formatValidInputClass(validations.countryID)}
                  placeholder={getResource('SelectCountry')}
                  notFoundContent={getResource('PlaceHolder.NoResults')}
                  value={countryID}
                  onSelect={countryChangeHandler}
                  onSearch={onSearch}
                disabled={props.customerInfoUsed}
                />
              </div>
            </div>
          </div>
        <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.ProvinceState') + '(*)'}</span>
              </div>
              <div className="row">
                <Dropdown name="state" title={getResource('SelectState')} list={states}
                  select={{ value: stateID }} onChange={stateChangeHandler}
                  errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.stateID)}
                disabled={props.customerInfoUsed}
                />
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.PostalZip')}</span>
              </div>
              <div className="row">
              <Input type="text" onChange={onChangePostalCode} value={postalCode} disabled={props.customerInfoUsed}></Input>
            </div>
          </div>
        </div>
      </div>
    );
}
export default BeneficiayInformation;